import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {HTH} from "../HTH";
import {gsap} from "gsap";
import {HTHSymbol} from "../symbols/HTHSymbol";
import {HTHEnhancerSymbol} from "../symbols/HTHEnhancerSymbol";

export class HTHEnhancerUnlockedPresentation implements SimplePresentation {

    constructor() {
    }

    shouldRun(): boolean {
        return HTH.model.consecutiveAvalanches >= 1 && HTH.model.consecutiveAvalanches < 6;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => controller.finish()});

        tl.add(() => controller.setSkipCallback(() => {
            tl.timeScale(1.5);
        }));
        tl.to(this, {duration: 0.01});
        const totalAvalancheOccurred: number = JSON.parse(JSON.stringify(HTH.model.consecutiveAvalanches));
        // enhancer block active animation
        for (let i: number = 1; i < 5; i++) {
            // if (i === totalAvalancheOccurred -1) {
            if (i === totalAvalancheOccurred) {
                const sym: HTHSymbol = HTH.reelArea.getSymbol([i, HTH.reelArea.allReels[i].reelView.getAllSymbols().length - 1]);
                tl.add((<HTHEnhancerSymbol>sym).unlockSymbol());
                (<HTHEnhancerSymbol>sym).isEnhancerOpen = true;
            }
        }

        tl.to(this, {duration: 0.05});
    }

}